import React from "react"
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import { fetchBolsa } from '../actions'
import { getBolsas } from '../reducers'
import {
    Box,
    Button,
    useColorModeValue,
    Tag
} from '@chakra-ui/react'
import Layout from '../layout'
import DataTable from 'react-data-table-component'


const columns = [
    { name: 'Fecha creación', selector: row => row.fecha, sortable: true },
    { name: 'Titulo', selector: row => row.title, sortable: true },
    { name: 'Estado', selector: row => row.active, sortable: true },
    { name: 'Opciones', selector: row => row.opcion, sortable: false },
];

class BolsaList extends React.Component {

    componentDidMount() {
        this.props.fetchBolsa()
    }

    getColor = () => useColorModeValue('white', 'gray.800')

    render() {
        const { posts } = this.props

        return (
            <Layout>
                <Box
                    w={'full'}
                    bg={this.getColor}
                    rounded={'md'}
                    m={3}
                    p={6}
                >
                    <DataTable
                        pagination
                        columns={columns}
                        defaultSortAsc={false}
                        defaultSortFieldId={1}
                        data={posts.map(post => {
                            let time = new Date(post.created_at)
                            return {
                                id: post.id,
                                fecha: time.toLocaleString(),
                                title: post.title,
                                active: post.active ? "Activo" : "Inactivo",
                                opcion: <>
                                <Link to={`/bolsa/${post.id}/edit`}><Button colorScheme="teal" variant="outline">Editar</Button></Link>
                                <Link to={`/bolsa/${post.id}/view`}><Button colorScheme="blue" variant="outline">Ver más</Button></Link>
                                </>
                            }
                        })}
                    />
                </Box>
                <Link to={`/bolsa/create`}><Button colorScheme="easycar2">Nuevo Puesto</Button></Link>
            </Layout >
        )
    }
}

const mapStateToProps = (state) => ({
    posts: getBolsas(state)
})

const mapDispatchToProps = { fetchBolsa }

export default connect(mapStateToProps, mapDispatchToProps)(BolsaList)